'use strict';

exports.__esModule = true;

var _Provider = require('./components/Provider');

Object.defineProperty(exports, 'Provider', {
  enumerable: true,
  get: function get() {
    return _Provider.default;
  }
});

var _connect = require('./components/connect');

Object.defineProperty(exports, 'connect', {
  enumerable: true,
  get: function get() {
    return _connect.default;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux/lib/index.js
 ** module id = 136
 ** module chunks = 0
 **/